import React, { createContext, useContext, useReducer } from 'react';

import { UserTypeGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

export type GlobalContextProps = {
  setLoginUserType: (userType: UserTypeGQLType) => void;
  loginUserType: UserTypeGQLType;
};

const appReducer = (state: any, action: { type: string; payload: any }) => {
  switch (action.type) {
    case 'SET_LOGIN_USER_TYPE':
      return {
        ...state,
        loginUserType: action.payload,
      };
    case 'SET_LOGIN_DATA':
      return {
        ...state,
        user: {
          ...state.user,
          id: action.payload.id,
          userType: action.payload.userType,
          email: action.payload.email,
        },
      };
    default:
      return state;
  }
};

// Initial state
const initialState: {
  loginUserType: UserTypeGQLType;
} = {
  loginUserType: 'BORROWER',
};

//  Create context
export const GlobalContext = createContext<null | GlobalContextProps>(null);

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (context === null) {
    throw new Error('No global context provider');
  }

  return context;
};

// Provider component
export const GlobalProvider = ({ children }: { children: any }) => {
  const [state, dispatch]: any = useReducer(appReducer, initialState);

  const setLoginUserType = (userType: UserTypeGQLType) => {
    dispatch({
      type: 'SET_LOGIN_USER_TYPE',
      payload: userType,
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        ...state,
        setLoginUserType,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
